import cn from 'classnames'
import throttle from 'lodash/throttle'
import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react'

export const ScrollOverflowFadeWrapper = forwardRef(({ placement = 'bottom', threshold }, ref) => {
  const initedRef = useRef(false)
  const [hideFirst, setHideFirst] = useState(false)
  const [hideLast, setHideLast] = useState(false)

  const checkScrollState = useCallback(
    elem => {
      initedRef.current = true
      const { scrollWidth, scrollHeight, scrollTop, scrollLeft, clientWidth, clientHeight } = elem
      if (placement === 'vertical' || placement === 'bottom') {
        if (scrollHeight <= clientHeight) {
          setHideFirst(true)
          setHideLast(true)
          return
        } else {
          setHideLast(scrollTop + clientHeight >= scrollHeight - (threshold ?? clientHeight / 8))
        }
      }
      if (placement === 'horizontal' || placement === 'right') {
        if (scrollWidth <= clientWidth) {
          setHideFirst(true)
          setHideLast(true)
          return
        } else {
          setHideLast(scrollLeft + clientWidth >= scrollWidth - (threshold ?? clientWidth / 8))
        }
      }
      if (placement === 'horizontal') setHideFirst(scrollLeft <= (threshold ?? clientWidth / 8))
      else if (placement === 'vertical') setHideFirst(scrollTop <= (threshold ?? clientHeight / 8))
    },
    [threshold, placement]
  )

  useEffect(() => {
    const elem = ref?.current ?? null
    if (!elem) return
    if (!initedRef.current) checkScrollState(elem)
    elem.addEventListener(
      'scroll',
      throttle(e => e.currentTarget && checkScrollState(e.currentTarget), 1000 / 60, { trailing: true })
    )
  }, [ref, checkScrollState])

  if (placement === 'bottom' || placement === 'right') return <FadeOverlay placement={placement} hide={hideLast} />
  return (
    <>
      <FadeOverlay placement={placement === 'horizontal' ? 'left' : 'top'} hide={hideFirst} />
      <FadeOverlay placement={placement === 'horizontal' ? 'right' : 'bottom'} hide={hideLast} />
    </>
  )
})

export const FadeOverlay = ({ placement, hide }) => {
  return (
    <div
      className={cn('fade-overlay pointer-events-none absolute cover', hide ? 'opacity-0' : 'opacity-100', {
        'fade-overlay-b': placement === 'bottom',
        'fade-overlay-t': placement === 'top',
        'fade-overlay-r': placement === 'right',
        'fade-overlay-l': placement === 'left',
      })}
    />
  )
}
